// Grade mapping: score ranges to letter grades with colors
export interface GradeInfo {
  grade: string;
  color: string;
  bgColor: string;
  borderColor: string;
  label: string;
  nextThreshold: number | null;
  nextGrade: string | null;
}

const GRADE_TABLE: Array<{ min: number; grade: string; color: string; label: string }> = [
  { min: 98, grade: 'A+', color: '#00CED1', label: 'Exceptional' },
  { min: 95, grade: 'A',  color: '#00CED1', label: 'Excellent' },
  { min: 92, grade: 'A-', color: '#00CED1', label: 'Very Good' },
  { min: 88, grade: 'B+', color: '#4545FF', label: 'Good' },
  { min: 85, grade: 'B',  color: '#4545FF', label: 'Above Average' },
  { min: 82, grade: 'B-', color: '#4545FF', label: 'Satisfactory' },
  { min: 78, grade: 'C+', color: '#F59E0B', label: 'Fair' },
  { min: 75, grade: 'C',  color: '#F59E0B', label: 'Below Average' },
  { min: 72, grade: 'C-', color: '#F59E0B', label: 'Marginal' },
  { min: 65, grade: 'D+', color: '#F97316', label: 'Poor' },
  { min: 50, grade: 'D',  color: '#F97316', label: 'Very Poor' },
  { min: 0,  grade: 'F',  color: '#EF4444', label: 'Critical' },
];

export function scoreToGrade(score: number): GradeInfo {
  for (let i = 0; i < GRADE_TABLE.length; i++) {
    if (score >= GRADE_TABLE[i].min) {
      const entry = GRADE_TABLE[i];
      const nextEntry = i > 0 ? GRADE_TABLE[i - 1] : null;
      return {
        grade: entry.grade,
        color: entry.color,
        bgColor: `${entry.color}15`,
        borderColor: `${entry.color}30`,
        label: entry.label,
        nextThreshold: nextEntry ? nextEntry.min : null,
        nextGrade: nextEntry ? nextEntry.grade : null,
      };
    }
  }
  return {
    grade: 'F',
    color: '#EF4444',
    bgColor: '#EF444415',
    borderColor: '#EF444430',
    label: 'Critical',
    nextThreshold: 50,
    nextGrade: 'D',
  };
}

export function gradeToColor(grade: string): string {
  const entry = GRADE_TABLE.find(g => g.grade === grade);
  return entry?.color || '#EF4444';
}

export function pointsToNextGrade(score: number): { points: number; nextGrade: string } | null {
  const info = scoreToGrade(score);
  if (!info.nextThreshold || !info.nextGrade) return null;
  return {
    points: Math.ceil(info.nextThreshold - score),
    nextGrade: info.nextGrade,
  };
}
